<template>
    <section class="live-controller"
        @click.stop="handleStopPropagation">
        <div class="live-controller-button"
            :class="{ 'pause': isPlaying }"
            @click.stop="handleTogglePlay"></div>
        <div class="live-controller-line"
            @click.stop="handleClick($event)"
            @touchmove.stop="handleMove($event)">
            <div class="live-controller-line-current"
                :style="{ 'width': currentLineLength }"></div>
        </div>
        <div class="live-controller-timer">
            {{ current | formatSeconds(2) }}/{{ length | formatSeconds(2) }}
        </div>
    </section>
</template>

<script>
	/** eslint-disable */
	import formatSeconds from '../filters/format-seconds'

	export default {
		name: 'LiveController',
		props: {
			current: {
				type: Number,
				default: 0
			},
			length: {
				type: Number,
				default: 0
			},
			isPlaying: {
				type: Boolean,
				default: false
			},
			rotate: Boolean
		},
		data() {
			return {
				/**
				 * 缓存需要用到的dom元素
				 */
				buttonDom: null,
				buttonDomWidth: 0,
				lineDom: null,
				lineDomWidth: 0
			}
		},
		computed: {
			currentLineLength() {
				return `${this.current / this.length * 100}%`
			}
		},
		watch: {
			// 转屏时重新计算尺寸
			rotate() {
				setTimeout(() => {
					this.buttonDomWidth = this.buttonDom.offsetWidth
					this.lineDomWidth = this.lineDom.offsetWidth
				}, 200)
			}
		},
		filters: {
			formatSeconds
		},
		mounted() {
			this.buttonDom = this.$el.querySelector('.live-controller-button')
			this.lineDom = this.$el.querySelector('.live-controller-line')
			this.buttonDomWidth = this.buttonDom.offsetWidth
			this.lineDomWidth = this.lineDom.offsetWidth
		},
		methods: {
			seek(time) {
				this.$emit('seek', time)
			},
			handleStopPropagation() {},
			handleTogglePlay() {
				// this.isPlaying = !this.isPlaying
				this.$emit('toggle')
			},
			handleClick(e) {
				let time
				if(this.rotate) {
					time = Math.floor((e.pageY - this.buttonDomWidth) / this.lineDomWidth * this.length)
				} else {
					time = Math.floor((e.pageX - this.buttonDomWidth) / this.lineDomWidth * this.length)
				}

				this.seek(time)
			},
			handleMove(e) {
        let time
        if(this.rotate) {
          time = Math.floor((e.touches[0].pageY - this.buttonDomWidth) / this.lineDomWidth * this.length)
        } else {
          time = Math.floor((e.touches[0].pageX - this.buttonDomWidth) / this.lineDomWidth * this.length)
        }
				this.seek(time)
			}
		}
	}
</script>

<style lang="scss" scoped>
    @import '../style/main.scss';

    .live-controller {
        display: flex;
        transform: translateZ(1px);
        position: absolute;
        right: 0;
        bottom: 0;
        left: 0;
        width: 100%;
        height: rem(76);
        background-color: rgba(#333, .8);

        &-button {
            $size: rem(76);
            box-sizing: border-box;
            padding: rem(24) 0;
            width: $size;
            height: $size;
            text-align: center;

            &::after {
                $size: rem(25);
                content: '';
                display: inline-block;
                width: rem(23);
                height: rem(28);
                background-image: url('./VideoController/video-control/img/play.png?__inline');
                background-size: 100% 100%;
            }

            &.pause {
                &::after {
                    background-image: url('./VideoController/video-control/img/pause.png?__inline');
                }
            }
        }

        /** button end **/

        &-line {
            flex: 1;
            position: relative;
            padding: rem(33) 0;

            &::before {
                content: '';
                transform: translateY(-50%);
                position: absolute;
                top: 50%;
                left: 0;
                width: 100%;
                height: rem(10);
                border-radius: 3px;
                background-color: rgba(#fff, .3);
            }

            &-current {
                transform: translateY(-50%);
                position: absolute;
                top: 50%;
                left: 0;
                padding-left: rem(20);
                width: 0;
                height: rem(10);
                border-radius: 3px;
                background-color: #ecd228;

                &::after {
                    $size: rem(10);
                    content: '';
                    transform: translateY(-50%);
                    position: absolute;
                    top: 50%;
                    right: 0;
                    width: $size;
                    height: $size;
                    border: rem(8) solid #fff;
                    border-radius: 50%;
                    background-color: #ecd228;
                }
            }
        }

        &-timer {
            padding: rem(24) rem(12);
            width: rem(160);
            text-align: center;
            font-size: rem(26);
            color: #fff;
        }
    }
</style>
